'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDayPicker = require('react-day-picker');

var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);

var _onlinepbxTableInput = require('../onlinepbx-table/onlinepbx-table-input');

var _onlinepbxTableInput2 = _interopRequireDefault(_onlinepbxTableInput);

var _helpers = require('./helpers');

var _onlinepbxButtonLink = require('../onlinepbx-button-link');

var _onlinepbxButtonLink2 = _interopRequireDefault(_onlinepbxButtonLink);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactPerfectScrollbar = require('react-perfect-scrollbar');

var _reactPerfectScrollbar2 = _interopRequireDefault(_reactPerfectScrollbar);

var _formatDate = require('../../helpers/format-date');

var _formatDate2 = _interopRequireDefault(_formatDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArrowRightIcon = function () {
  function ArrowRightIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M7.5 17l5-5-5-5',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return ArrowRightIcon;
}();

ArrowRightIcon.defaultProps = {
  width: '20',
  height: '24',
  viewBox: '0 0 20 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var ArrowLeftIcon = function () {
  function ArrowLeftIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M12.5 15l-5-5 5-5',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return ArrowLeftIcon;
}();

ArrowLeftIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var CalendarIcon = function () {
  function CalendarIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M15.833 3.333H4.167C3.247 3.333 2.5 4.08 2.5 5v11.667c0 .92.746 1.666 1.667 1.666h11.666c.92 0 1.667-.746 1.667-1.666V5c0-.92-.746-1.667-1.667-1.667zM13.333 1.667V5M6.667 1.667V5M2.5 8.333h15',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return CalendarIcon;
}();

CalendarIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var OnlinepbxCalendar = function (_React$Component) {
  _inherits(OnlinepbxCalendar, _React$Component);

  function OnlinepbxCalendar(props) {
    _classCallCheck(this, OnlinepbxCalendar);

    var _this = _possibleConstructorReturn(this, (OnlinepbxCalendar.__proto__ || Object.getPrototypeOf(OnlinepbxCalendar)).call(this, props));

    _this.state = {
      initialMonth: new Date(),
      isIconClick: false,
      isOpenMonthsModal: false,
      selectedDays: null,
      isOpen: false,
      customValue: null
    };
    _this.isCursor = true;
    _this.resetCalendar = _this.resetCalendar.bind(_this);
    _this.handleUp = _this.handleUp.bind(_this);
    _this.domNode = document.createElement('div');
    _this.renderModal = _this.renderModal.bind(_this);
    _this.handleDown = _this.handleDown.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleUpdate = _this.handleUpdate.bind(_this);
    _this.handleSave = _this.handleSave.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleInput = _this.handleInput.bind(_this);

    _this.maxInitialMonth = new Date();
    _this.maxInitialMonth.setMonth(_this.maxInitialMonth.getMonth() + 1);
    _this.maxInitialMonth.setDate(0);
    _this.maxInitialMonth.setHours(23);
    _this.maxInitialMonth.setMinutes(59);
    _this.maxInitialMonth.setSeconds(59);
    _this.maxInitialMonth.setMilliseconds(999);

    if (_this.props.minDate) {
      _this.minInitialMonth = new Date(_this.props.minDate);
      _this.minInitialMonth.setDate(0);
      _this.minInitialMonth.setHours(0);
      _this.minInitialMonth.setMinutes(0);
      _this.minInitialMonth.setSeconds(0);
      _this.minInitialMonth.setMilliseconds(0);
    }
    return _this;
  }

  _createClass(OnlinepbxCalendar, [{
    key: 'resetCalendar',
    value: function () {
      function resetCalendar() {
        var initialMonth = new Date(new Date(this.props.date).getFullYear(), new Date(this.props.date).getMonth());
        var date = new Date(this.props.date);
        if (this.props.minDate && Number(initialMonth) < Number(this.minInitialMonth)) {
          initialMonth.setYear(this.minInitialMonth.getFullYear());
          initialMonth.setMonth(this.minInitialMonth.getMonth());
        } else if (Number(initialMonth) > Number(this.maxInitialMonth)) {
          initialMonth.setYear(this.maxInitialMonth.getFullYear());
          initialMonth.setMonth(this.maxInitialMonth.getMonth());
        }
        this.setState(_extends({
          initialMonth: initialMonth,
          selectedDays: date
        }, this.props.isClose ? { isOpen: false, customValue: null, isIconClick: false, isOpenMonthsModal: false } : {}));
      }

      return resetCalendar;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        this.resetCalendar();
        this.handleUpdate();
        var containers = document.querySelectorAll('.scrollbar__dark');
        containers.forEach(function (container) {
          return container.addEventListener('scroll', _this2.handleUpdate);
        });
        document.body.appendChild(this.domNode);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        var _this3 = this;

        var containers = document.querySelectorAll('.scrollbar__dark');
        containers.forEach(function (container) {
          return container.removeEventListener('scroll', _this3.handleUpdate);
        });
        document.body.removeChild(this.domNode);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'handleUpdate',
    value: function () {
      function handleUpdate() {
        this.setState({
          isOpen: false,
          position: this.input && this.input.getBoundingClientRect()
        });
      }

      return handleUpdate;
    }()
  }, {
    key: 'handleUp',
    value: function () {
      function handleUp() {
        var newInitialMonth = new Date(this.state.initialMonth);
        newInitialMonth.setMonth(newInitialMonth.getMonth() - 1);
        if (!this.props.unlimited && this.props.minDate && Number(newInitialMonth) < Number(this.minInitialMonth)) return;

        this.setState({ initialMonth: newInitialMonth });
      }

      return handleUp;
    }()
  }, {
    key: 'handleDown',
    value: function () {
      function handleDown() {
        var newInitialMonth = new Date(this.state.initialMonth);
        newInitialMonth.setMonth(newInitialMonth.getMonth() + 1);
        if (!this.props.unlimited && !this.props.minDate && Number(newInitialMonth) > Number(this.maxInitialMonth)) return;

        this.setState({ initialMonth: newInitialMonth });
      }

      return handleDown;
    }()
  }, {
    key: 'handleClick',
    value: function () {
      function handleClick(newDate) {
        if (!newDate) return;
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        newDate.setMinutes(0);
        newDate.setHours(0);
        if (!this.props.unlimited && !this.props.minDate && Number(newDate) > Date.now()) {
          var dateNow = new Date();
          newDate.setDate(dateNow.getDate());
          newDate.setMonth(dateNow.getMonth());
          newDate.setYear(dateNow.getFullYear());
        } else if (!this.props.unlimited && Number(newDate) <= Number(new Date(this.props.minDate))) {
          var minDate = new Date(this.props.minDate);
          newDate.setDate(minDate.getDate());
          newDate.setMonth(minDate.getMonth());
          newDate.setYear(minDate.getFullYear());
        }

        this.setState({ selectedDays: newDate, customValue: null });
        var _props$isButtons = this.props.isButtons,
            isButtons = _props$isButtons === undefined ? true : _props$isButtons;

        !isButtons && this.handleSave(newDate);
      }

      return handleClick;
    }()
  }, {
    key: 'handleSave',
    value: function () {
      function handleSave(date) {
        this.props.setDate(Number(date) || Number(this.state.selectedDays));
        this.setState({ isOpen: false, customValue: null, isIconClick: false, isOpenMonthsModal: false });
      }

      return handleSave;
    }()
  }, {
    key: 'handleBlur',
    value: function () {
      function handleBlur() {
        var _props$isButtons2 = this.props.isButtons,
            isButtons = _props$isButtons2 === undefined ? true : _props$isButtons2;


        if (!this.state.customValue) {
          isButtons ? this.resetCalendar() : this.handleSave();
          return;
        }
        var customValue = this.state.customValue;

        var _customValue$trim$spl = customValue.trim().split('.'),
            _customValue$trim$spl2 = _slicedToArray(_customValue$trim$spl, 3),
            dateOfMonth = _customValue$trim$spl2[0],
            month = _customValue$trim$spl2[1],
            year = _customValue$trim$spl2[2];

        var date = new Date(String(year) + '.' + String(month) + '.' + String(dateOfMonth));

        date.setSeconds(0);
        date.setMilliseconds(0);
        date.setMinutes(0);
        date.setHours(0);

        if (!this.props.unlimited && !this.props.minDate && Number(date) > Date.now()) {
          var dateNow = new Date();
          date.setDate(dateNow.getDate());
          date.setMonth(dateNow.getMonth());
          date.setYear(dateNow.getFullYear());
        } else if (!this.props.unlimited && Number(date) <= Number(new Date(this.props.minDate))) {
          var minDate = new Date(this.props.minDate);
          date.setDate(minDate.getDate());
          date.setMonth(minDate.getMonth());
          date.setYear(minDate.getFullYear());
        }

        this.setState({ selectedDays: date, customValue: null });
        isButtons ? this.isCursor && this.resetCalendar() : this.handleSave(date);
      }

      return handleBlur;
    }()
  }, {
    key: 'handleChange',
    value: function () {
      function handleChange(evt) {
        this.setState({ customValue: evt.target.value || '' });
      }

      return handleChange;
    }()
  }, {
    key: 'handleInput',
    value: function () {
      function handleInput(evt) {
        var reg = /^\s*(3[01]|[12][\d]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/g;
        var value = evt.target.value;

        if (!reg.test(value)) return;

        var newDate = new Date(value.trim().split('.').reverse().join('-'));
        var date = new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate(), 0, 0, 0, 0));

        this.setState({ selectedDays: date, initialMonth: date, customValue: null });
      }

      return handleInput;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps, prevState) {
        if (prevProps.minDate !== this.props.minDate) {
          this.minInitialMonth = new Date(this.props.minDate);
          this.minInitialMonth.setDate(0);
          this.minInitialMonth.setHours(0);
          this.minInitialMonth.setMinutes(0);
          this.minInitialMonth.setSeconds(0);
          this.minInitialMonth.setMilliseconds(0);
        }

        if (!this.state.isOpen && this.props.date !== prevProps.date) {
          var initialMonth = new Date(new Date(this.props.date).getFullYear(), new Date(this.props.date).getMonth());
          var date = new Date(this.props.date);
          if (this.props.minDate && Number(initialMonth) < Number(this.minInitialMonth)) {
            initialMonth.setYear(this.minInitialMonth.getFullYear());
            initialMonth.setMonth(this.minInitialMonth.getMonth());
          } else if (Number(initialMonth) > Number(this.maxInitialMonth)) {
            initialMonth.setYear(this.maxInitialMonth.getFullYear());
            initialMonth.setMonth(this.maxInitialMonth.getMonth());
          }
          this.setState({
            initialMonth: initialMonth,
            selectedDays: date
          });
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;

        var _state = this.state,
            selectedDays = _state.selectedDays,
            customValue = _state.customValue;
        var _props = this.props,
            label = _props.label,
            _props$formatDate = _props.formatDate,
            formatDate = _props$formatDate === undefined ? _formatDate2['default'] : _props$formatDate,
            warningText = _props.warningText,
            disabled = _props.disabled,
            _props$isShowIcon = _props.isShowIcon,
            isShowIcon = _props$isShowIcon === undefined ? true : _props$isShowIcon,
            _props$hasInput = _props.hasInput,
            hasInput = _props$hasInput === undefined ? false : _props$hasInput;

        return _react2['default'].createElement(
          'div',
          { className: 'onlinepbx__lib__calendar__wrapper' },
          _react2['default'].createElement(
            'div',
            {
              ref: function () {
                function ref(node) {
                  if (node && !_this4.input) {
                    _this4.forceUpdate();
                  }
                  _this4.input = node || _this4.input;
                }

                return ref;
              }(),
              className: 'onlinepbx__lib__calendar__input' },
            _react2['default'].createElement(_onlinepbxTableInput2['default'], {
              onKeyDown: function () {
                function onKeyDown(evt) {
                  if (evt.keyCode === 13) {
                    _this4.isCursor = true;
                    evt.target.blur();
                  }
                }

                return onKeyDown;
              }(),
              onFocus: function () {
                function onFocus() {
                  return _this4.setState({ isOpen: true });
                }

                return onFocus;
              }(),
              onBlur: function () {
                function onBlur() {
                  return _this4.isCursor && _this4.handleBlur();
                }

                return onBlur;
              }(),
              label: label,
              disabled: disabled,
              warningText: warningText,
              value: customValue === null ? formatDate(selectedDays) : customValue,
              onChange: this.handleChange,
              onInput: hasInput && this.handleInput
            }),
            isShowIcon && _react2['default'].createElement(CalendarIcon, {
              onClick: function () {
                function onClick() {
                  !disabled && _this4.setState({ isOpen: !_this4.state.isOpen, isIconClick: true });
                }

                return onClick;
              }(),
              className: 'onlinepbx__lib__calendar__input__icon'
            })
          ),
          this.state.isOpen && _reactDom2['default'].createPortal(this.renderModal(selectedDays), this.domNode)
        );
      }

      return render;
    }()
  }, {
    key: 'renderModal',
    value: function () {
      function renderModal(resultSelectedDays) {
        var _this5 = this;

        var initialMonth = this.state.initialMonth;
        var _props2 = this.props,
            isPeriods = _props2.isPeriods,
            _props2$isButtons = _props2.isButtons,
            isButtons = _props2$isButtons === undefined ? true : _props2$isButtons,
            unlimited = _props2.unlimited,
            minDate = _props2.minDate;

        return _react2['default'].createElement(
          'div',
          {
            tabIndex: '1',
            style: this.state.position && {
              width: this.input && this.input.offsetWidth,
              top: this.state.position.y >= document.body.clientHeight / 2.4 ? 'auto' : this.state.position.top + 52,
              bottom: this.state.position.y >= document.body.clientHeight / 2.4 ? document.body.clientHeight - this.state.position.bottom + 55 : 'auto',
              left: this.state.position.x
            },
            ref: function () {
              function ref(node) {
                return _this5.state.isIconClick && node && node.focus();
              }

              return ref;
            }(),
            onMouseEnter: function () {
              function onMouseEnter() {
                _this5.isCursor = false;
              }

              return onMouseEnter;
            }(),
            onMouseLeave: function () {
              function onMouseLeave() {
                _this5.isCursor = true;
              }

              return onMouseLeave;
            }(),
            onBlur: function () {
              function onBlur() {
                return _this5.isCursor && setTimeout(_this5.resetCalendar, 200, true);
              }

              return onBlur;
            }(),
            className: 'onlinepbx__lib__calendar__modal' },
          _react2['default'].createElement(
            'div',
            { className: 'onlinepbx__lib__calendar__modal__content' },
            isPeriods && _react2['default'].createElement(
              'div',
              {
                onClick: function () {
                  function onClick() {
                    return _this5.setState({ isOpenMonthsModal: false });
                  }

                  return onClick;
                }(),
                className: 'onlinepbx__lib__calendar__modal__content__select' },
              _helpers.localeUtils.getPeriods().map(function (change) {
                return _react2['default'].createElement(
                  'div',
                  { className: 'onlinepbx__lib__calendar__modal__content__option' },
                  _react2['default'].createElement(_onlinepbxButtonLink2['default'], {
                    onClick: function () {
                      function onClick() {
                        return _this5.handleClickPeriod(change.period);
                      }

                      return onClick;
                    }(),
                    text: change.title
                  })
                );
              })
            ),
            _react2['default'].createElement(
              'div',
              {
                onClick: function () {
                  function onClick() {
                    return _this5.setState({ isOpenMonthsModal: false });
                  }

                  return onClick;
                }(),
                className: 'onlinepbx__lib__calendar' },
              _react2['default'].createElement(_reactDayPicker2['default'], {
                locale: _helpers.defaultLanguage,
                localeUtils: _helpers.localeUtils,
                selectedDays: resultSelectedDays,
                numberOfMonths: 1,
                firstDayOfWeek: 1,
                captionElement: function () {
                  function captionElement(_ref) {
                    var date = _ref.date,
                        localeUtils = _ref.localeUtils;

                    return _react2['default'].createElement(
                      'div',
                      null,
                      _react2['default'].createElement(
                        'div',
                        { className: 'onlinepbx__lib__calendar__year' },
                        date.getFullYear()
                      ),
                      _react2['default'].createElement(
                        'div',
                        { className: 'onlinepbx__lib__calendar__month' },
                        _react2['default'].createElement(
                          'button',
                          {
                            disabled: !unlimited && minDate && initialMonth.getMonth() === _this5.minInitialMonth.getMonth() && initialMonth.getYear() === _this5.minInitialMonth.getYear(),
                            onClick: _this5.handleUp,
                            className: 'onlinepbx__lib__calendar__prev'
                          },
                          _react2['default'].createElement(ArrowLeftIcon, { className: 'onlinepbx__lib__calendar__prev__icon' })
                        ),
                        _react2['default'].createElement(
                          'div',
                          { className: 'onlinepbx__lib__calendar__month__head' },
                          _react2['default'].createElement(
                            'div',
                            {
                              onClick: function () {
                                function onClick(evt) {
                                  evt.stopPropagation();
                                  _this5.setState({ isOpenMonthsModal: !_this5.state.isOpenMonthsModal });
                                }

                                return onClick;
                              }(),
                              className: 'onlinepbx__lib__calendar__month__text' },
                            localeUtils.formatMonthTitle(date)
                          ),
                          _this5.state.isOpenMonthsModal && _react2['default'].createElement(
                            'div',
                            { className: 'onlinepbx__lib__calendar__month__modal' },
                            _react2['default'].createElement(
                              _reactPerfectScrollbar2['default'],
                              {
                                className: 'scrollbar__dark onlinepbx__lib__calendar__month__modal__scrollbar' },
                              localeUtils.getMonth(date, 120, 12).map(function (month) {
                                return _react2['default'].createElement(
                                  'div',
                                  {
                                    tabIndex: '0',
                                    onBlur: function () {
                                      function onBlur() {
                                        return _this5.isCursor && _this5.setState({ isOpenMonthsModal: false });
                                      }

                                      return onBlur;
                                    }(),
                                    className: (0, _classnames2['default'])('onlinepbx__lib__calendar__month__option', {
                                      'onlinepbx__lib__calendar__month__option__active': initialMonth.getMonth() === month.getMonth() && initialMonth.getYear() === month.getYear()
                                    }),
                                    onClick: function () {
                                      function onClick() {
                                        return _this5.setState({ initialMonth: month, isOpenMonthsModal: false });
                                      }

                                      return onClick;
                                    }() },
                                  _react2['default'].createElement(
                                    'div',
                                    null,
                                    localeUtils.formatMonthTitle(month)
                                  ),
                                  _react2['default'].createElement(
                                    'div',
                                    { className: 'onlinepbx__lib__calendar__year' },
                                    localeUtils.formatYearTitle(month)
                                  )
                                );
                              })
                            )
                          )
                        ),
                        _react2['default'].createElement(
                          'button',
                          {
                            disabled: !unlimited && !minDate && initialMonth.getMonth() === _this5.maxInitialMonth.getMonth() && initialMonth.getYear() === _this5.maxInitialMonth.getYear(),
                            onClick: _this5.handleDown,
                            className: 'onlinepbx__lib__calendar__next' },
                          _react2['default'].createElement(ArrowRightIcon, { className: 'onlinepbx__lib__calendar__next__icon' })
                        )
                      )
                    );
                  }

                  return captionElement;
                }(),
                modifiers: { holidays: { daysOfWeek: [0] } },
                onDayClick: this.handleClick,
                onDayMouseEnter: this.dayEnter,
                month: initialMonth
              }),
              isButtons && _react2['default'].createElement(
                'div',
                { className: 'onlinepbx__lib__calendar__buttons' },
                _react2['default'].createElement(
                  'div',
                  { className: 'onlinepbx__lib__calendar__button' },
                  _react2['default'].createElement(_onlinepbxButtonLink2['default'], {
                    onClick: function () {
                      function onClick() {
                        return _this5.resetCalendar();
                      }

                      return onClick;
                    }(),
                    text: '\u041E\u0442\u043C\u0435\u043D\u0430'
                  })
                ),
                _react2['default'].createElement(
                  'div',
                  { className: 'onlinepbx__lib__calendar__button' },
                  _react2['default'].createElement(_onlinepbxButtonLink2['default'], {
                    onClick: function () {
                      function onClick() {
                        return _this5.handleSave();
                      }

                      return onClick;
                    }(),
                    text: '\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C'
                  })
                )
              )
            )
          )
        );
      }

      return renderModal;
    }()
  }]);

  return OnlinepbxCalendar;
}(_react2['default'].Component);

exports['default'] = OnlinepbxCalendar;